import { baseAPI } from '~shared/api/base-api';

interface DroppedClassReportParams {
  startDate: string;
  endDate: string;
  format: string;
}

export const reportingDroppedClassReportAPI = async (
  params: DroppedClassReportParams,
) => {
  const response = await baseAPI.get<string>(
    '/reporting/dropped-class-report',
    { params },
  );
  return response.data;
};
